import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IJobCandidateInteraction } from 'wisestep-api';
import { WsColors, WsDrawer } from 'wisestep-base';

import { setDefaultCandidateAdvanceFilters } from '../../../features/candidates/utils/CandidateHelper';
import {
  CreatedBwDatesFilter,
  CurrentEmployersFilter,
  JobTitleFilter,
  LanguagesFilter,
  NoticePeriod,
  PreviousEmployersFilter,
  SalaryRangeFilter,
  SourceFilter,
  TotalExperienceFilter,
} from '../components';
import AdvanceFilterFooterBar from '../components/AdvanceFilterFooterBar';
import {
  contactPreferences,
  jobPreferences,
  workAuthorization,
} from '../components/AdvanceFilterHelper';
import CheckboxListFilter from '../components/CheckboxListFilter';
import JobTypeFilter from '../components/JobTypeFilter';
import TagsFilter from '../components/TagsFilter';
import TalentPoolAdvanceFilterFormProps from '../models/TalentPoolAdvanceFiltersFormProps';
import TalentPoolAdvanceFilterProps from '../models/TalentPoolAdvanceFiltersProps';

export const FilterTitle = styled(Typography)(() => ({
  fontsize: '14px',
  fontWeight: 'bold',
  color: WsColors.GenericRichBlack,
}));

const WSTalentPoolAdvanceFilters = ({
  open,
  filterClose,
  onApplyFilters,
  defaultValues,
}: TalentPoolAdvanceFilterProps) => {
  const methods = useForm<TalentPoolAdvanceFilterFormProps>({
    defaultValues: defaultValues,
  });
  const { handleSubmit, reset } = methods;

  const onFormSubmit = (data: TalentPoolAdvanceFilterFormProps) => {
    onApplyFilters(data);
    filterClose();
  };
  const candidateStatus = {
    submitted: 'Submitted',
    uploaded: 'uploaded',
    applied: 'applied',
  };
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);
  return (
    <FormProvider {...methods}>
      <WsDrawer
        title="Advanced Filters"
        open={open}
        onClose={() => filterClose()}
        size="medium"
        headerSize="medium"
      >
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(onFormSubmit)}
          onReset={() => {
            reset(setDefaultCandidateAdvanceFilters({} as IJobCandidateInteraction));
            onFormSubmit({});
          }}
        >
          <Box pb={7}>
            <List>
              <JobTitleFilter name="jobTitles" title="Job Title(s)" />
              <CreatedBwDatesFilter
                name="createBWDates.fromDateName"
                name1="createBWDates.toDateName"
              />
              <CheckboxListFilter
                name="workAuthorization"
                options={workAuthorization}
                title="Work Authorization"
              />
              <SourceFilter name="source" defaultValue={defaultValues.source} />
              <CheckboxListFilter
                name="commPreference"
                options={contactPreferences}
                title="Communication Preference"
              />
              <CurrentEmployersFilter
                name="currentEmployers"
                defaultValue={defaultValues.currentEmployers}
              />
              <PreviousEmployersFilter
                name="previousEmployers"
                defaultValue={defaultValues.previousEmployers}
              />
              <CheckboxListFilter
                name="contactAvailability"
                options={contactPreferences}
                title="Contact Availability"
              />
              <SalaryRangeFilter />
              <NoticePeriod name="noticePeriod" />
              <LanguagesFilter name="languages" />
              <JobTypeFilter name="jobType" />
              <CheckboxListFilter
                name="jobPreference"
                options={jobPreferences}
                title="Job Preference"
              />
              <TotalExperienceFilter />
              {/* <ClientNamesFilter
                title="Client Name(s)"
                name="clientNames"
                placeHolder="Filter by Client Names"
              /> */}
              {/* <ClientRecruitersFilter
                title="Client Recruiter(s)"
                name="clientRecruiters"
                placeHolder="Add by Name (or) Email"
              /> */}
              {/* <AccountManagerFilter title="Account Mananger(s)" name="accountManager" /> */}
              {/* <RecruitersFilter title="Recruiter(s)" name="recruiters" /> */}
              {/* <TeamFilter title="Team" name="teams" placeHolder="Filter by Team Names" /> */}
              <CheckboxListFilter name="candidateStatus" options={candidateStatus} title="Status" />
              {/* <StageStatusFilter name="stageStatus" /> */}
              <TagsFilter name="tags" defaultValue={defaultValues.tags} />
            </List>
          </Box>
          <AdvanceFilterFooterBar />
        </Box>
      </WsDrawer>
    </FormProvider>
  );
};
export default WSTalentPoolAdvanceFilters;
